import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader, fmt, StatusBadge, fmtDateTime, EmptyState } from "@/components/shared";
import { AdminPageHeader } from "./adminShared";

export default function AdminReferrals() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/referrals").then((r) => setItems(r.data)); }, []);
  if (items === null) return <Loader />;
  const filtered = q ? items.filter((r) => (r.referrer_name + r.referred_name).toLowerCase().includes(q.toLowerCase())) : items;

  return (
    <div data-testid="admin-referrals">
      <AdminPageHeader eyebrow="Management" title="Referral Rewards"
        right={<input data-testid="referral-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search referrer/referred..."
          className="bg-slate-900/60 border border-cyan-500/20 rounded-lg px-4 py-2 text-sm text-slate-200 focus:outline-none focus:border-cyan-400 w-full sm:w-72" />} />
      {filtered.length ? (
        <div className="glass rounded-2xl p-4 overflow-x-auto">
          <table className="w-full text-sm min-w-[800px]">
            <thead><tr className="text-left text-slate-500 border-b border-white/5">
              {["Referrer", "Referred User", "Deposit", "Percentage", "Reward", "Date", "Status"].map((h) => <th key={h} className="pb-3 px-2 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id} className="border-b border-white/5 last:border-0" data-testid={`referral-row-${r.id}`}>
                  <td className="py-3 px-2 text-slate-200">{r.referrer_name}</td>
                  <td className="py-3 px-2 text-slate-300">{r.referred_name}</td>
                  <td className="py-3 px-2 font-mono text-slate-300">{fmt(r.deposit_amount)}</td>
                  <td className="py-3 px-2 text-slate-400">{r.percentage}%</td>
                  <td className="py-3 px-2 font-mono text-emerald-300">+{fmt(r.reward_amount)}</td>
                  <td className="py-3 px-2 text-slate-500">{fmtDateTime(r.created_at)}</td>
                  <td className="py-3 px-2"><StatusBadge status={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <EmptyState title="No referral rewards yet" subtitle="Rewards appear when referred users' first deposits are approved." />}
    </div>
  );
}
